"use client";

import { Link, useLocation } from "react-router-dom";
import { useAnimalDetailDashboardTour } from "@/features/tour/officials.tour.ts";
import { Button } from "@heroui/button";
import { Info } from "lucide-react";

export function DashboardHeader() {
  const { pathname } = useLocation();
  const { startTour } = useAnimalDetailDashboardTour();

  const isDetailPage = pathname.startsWith("/animals/");

  return (
    <header className="w-full sticky top-0 z-50 overflow-x-hidden border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container overflow-hidden flex h-16 items-center justify-between">
        <div className="flex items-center gap-2">
          <Link className="flex items-center space-x-2" to="/guest/dashboard">
            <span className="text-xl font-bold">Animal Dashboard</span>
          </Link>
          {isDetailPage && (
            <div className="flex items-center">
              <span className="mx-2 text-muted-foreground">/</span>
              <span className="text-muted-foreground">Animal Details</span>
            </div>
          )}
        </div>
        <div>
          <Button
            isIconOnly
            size="sm"
            color="primary"
            variant="flat"
            // className="absolute top-4 right-4 z-30"
            className={"z-30 opacity-10"}
            startContent={<Info />}
            onPress={startTour}
          />
        </div>
      </div>
    </header>
  );
}
